import React, { useEffect } from 'react';

const Terms = () => {
  useEffect(() => {
    // Google Analytics事件跟踪
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_title: 'Terms of Service',
        page_location: '/terms',
        custom_parameters: {
          legal_page: 'terms',
          page_type: 'legal_document'
        }
      });
    }
  }, []);

  // Terms页面强制使用英文内容
  const englishContent = {
    title: "Terms of Service",
    acceptance: {
      title: "Acceptance of Terms",
      content: "By accessing and using the Online Notepad service, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service."
    },
    service: {
      title: "Service Description",
      content: "Online Notepad is a free browser-based text editor that allows users to create, edit, and save text documents. All data is stored locally in the user's browser, and we do not collect or store user content on our servers. The service provides autosave functionality, word counting, find and replace, and other text editing features to enhance your writing experience."
    },
    usage: {
      title: "Acceptable Use",
      content: "Users agree to use this service only for lawful purposes. You may not use the service for any illegal activities, distributing malware, or violating the rights of others. The service is designed for personal and professional note-taking and document creation."
    },
    privacy: {
      title: "Privacy Protection",
      content: "We are committed to protecting your privacy. Your document content is stored only in your browser locally, and we cannot access or view your data. All text editing happens entirely within your browser using HTML5 localStorage technology. Please refer to our Privacy Policy for more detailed information about data handling."
    },
    limitation: {
      title: "Limitation of Liability",
      content: "This service is provided 'as is' without any express or implied warranties. We are not liable for any loss or damage resulting from the use or inability to use the service. Users are responsible for backing up important documents and maintaining their own data security."
    },
    changes: {
      title: "Changes to Terms",
      content: "We reserve the right to modify these terms at any time. Modified terms will be posted on the website and will take effect immediately. Continued use of the service indicates acceptance of the modified terms."
    },
    contact: {
      title: "Contact Us",
      content: "If you have any questions about these Terms of Service, please contact us through the contact information provided on our website."
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{englishContent.title}</h1>
        <div className="legal-content">
          <section>
            <h2>{englishContent.acceptance.title}</h2>
            <p>{englishContent.acceptance.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.service.title}</h2>
            <p>{englishContent.service.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.usage.title}</h2>
            <p>{englishContent.usage.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.privacy.title}</h2>
            <p>{englishContent.privacy.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.limitation.title}</h2>
            <p>{englishContent.limitation.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.changes.title}</h2>
            <p>{englishContent.changes.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.contact.title}</h2>
            <p>{englishContent.contact.content}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;